export default function EcoFinca() {
  const ecoFeatures = [
    {
      icon: 'ri-leaf-line',
      title: 'Organiczne produkty',
      description: 'Własna plantacja bananów i warzyw dostarczających świeże produkty do restauracji hotelowych.'
    },
    {
      icon: 'ri-sun-line',
      title: 'Energia odnawialna',
      description: 'Wykorzystanie energii słonecznej i innych odnawialnych źródeł energii w całym obiekcie.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Plastic-free',
      description: 'Eliminacja plastiku jednorazowego użytku i wdrożenie ekologicznych alternatyw.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Zarządzanie wodą',
      description: 'Systemy oszczędzania wody i recyklingu w całym hotelu i na polu golfowym.'
    },
    {
      icon: 'ri-plant-line',
      title: 'Kompostowanie',
      description: 'Przetwarzanie odpadów organicznych na naturalny nawóz dla ogrodów i plantacji.'
    },
    {
      icon: 'ri-earth-line',
      title: 'Ochrona bioróżnorodności',
      description: 'Aktywna ochrona lokalnej flory i fauny oraz edukacja ekologiczna gości.'
    }
  ];

  return (
    <section id="eco-finca" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            Eco Finca – Odpowiedzialność i Natura
          </h2>
          <div className="w-24 h-1 bg-stone-300 mx-auto mb-8"></div>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Hotel Jardín Tecina to nie tylko miejsce wypoczynku, ale także przykład odpowiedzialnego podejścia do środowiska. Nasza Eco Finca dostarcza organiczne produkty i wspiera zrównoważony rozwój.
          </p>
        </div>

        {/* Galería de fotos reales de la Eco Finca */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          <div className="w-full h-96 rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://i.imgur.com/sI4TD6Z.jpg" 
              alt="Eco Finca Hotel Jardín Tecina - Plantación orgánica"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="w-full h-96 rounded-lg overflow-hidden shadow-lg">
            <img 
              src="https://i.imgur.com/EooPLeJ.jpg" 
              alt="Eco Finca Hotel Jardín Tecina - Agricultura sostenible"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {ecoFeatures.map((feature, index) => (
            <div key={index} className="bg-stone-50 rounded-lg p-6 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full mb-4">
                <i className={`${feature.icon} text-green-700 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-medium text-stone-800 mb-3">{feature.title}</h3>
              <p className="text-stone-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="bg-green-50 rounded-lg p-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-green-600 rounded-full mx-auto mb-4">
            <i className="ri-seedling-line text-white text-2xl"></i>
          </div>
          <h3 className="text-2xl font-medium text-stone-800 mb-4">Certyfikaty i zaangażowanie</h3>
          <p className="text-stone-600 leading-relaxed max-w-2xl mx-auto">
            Hotel Jardín Tecina jest aktywnie zaangażowany w ochronę środowiska i posiada certyfikaty potwierdzające nasze działania na rzecz zrównoważonego rozwoju. Dla Twoich klientów to gwarancja odpowiedzialnego wypoczynku.
          </p>
        </div>
      </div>
    </section>
  );
}